import { useQueryClient, useMutation } from '@tanstack/react-query';
import { quoteItemQueryKey } from '@services/quoteItem';
import { quoteFormQueryKeys } from '@services/quoteForm';
import { useClient } from '@utils/api-client';
import { ReactivateQuotePostRequestBody, ReactivateQuoteRequestParams } from '@lio/api-types';

export const useReactivateDeclinedRejectedQuote = () => {
  const queryClient = useQueryClient();
  const client = useClient();
  const mutationFn = ({
    quoteId,
    ...reactivateQuoteBody
  }: ReactivateQuotePostRequestBody & ReactivateQuoteRequestParams) => {
    const url = `quote/${quoteId}/reactivation`;
    return client.post(url, {
      json: reactivateQuoteBody,
    });
  };
  const result = useMutation({
    mutationFn,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['quote', { quoteId: variables.quoteId }] });
      queryClient.invalidateQueries({ queryKey: quoteItemQueryKey.searchWithParams({ quoteId: variables.quoteId }) });
      queryClient.invalidateQueries({ queryKey: quoteFormQueryKeys.get(variables.quoteId) });
      // Refresh the quote activity milestone feed so the reactivation shows without a page refresh.
      queryClient.invalidateQueries({ queryKey: ['status-change', { quoteId: variables.quoteId }] });
    },
  });
  return {
    ...result,
    reactivateQuote: result.mutateAsync,
  };
};
